import { Component,  OnDestroy,  OnInit, ViewChild } from '@angular/core';
import { TabsService } from '../../shared/components/tabs/tabs.service';
import { StorageService } from '../../shared/services/storage.service';
import { Router } from '@angular/router';
import { AgGridImportCommonDuplicatesTab, AgGridImportConsignmentDuplicate, AgGridImportOEMExcessDuplicate } from '../import-documents/pages/duplicates-tab/duplicates-tab.model';
import { CommonImportComponent } from '../../shared/components/common-import/common-import.component';
import { ImportDocumentsService } from '../import-documents/import-documents.service';
import { ToastrService } from 'ngx-toastr';
import { ImportTemplateFileName, ImportTemplateSource } from '../../shared/model/enum';
import { IMPORT_MODULE_REQUIRED_FIELDS, IMPORT_MODULE_SYSTEM_COLUMNS } from '../../shared/import/import-field-definitions';
import { CommonService } from '../../shared/services/common.service';
import { CommonImportDocumentService } from './common-import-document.service';
import { PartsListService } from '../parts-and-inventory/parts-list/pages/parts-list/parts-list.service';
import { AgGridImportCommonPreview, AgGridImportConsignmentPreview, AgGridImportInventoryPreview, AgGridImportOEMExcessPreview, AgGridImportVendorPartsPreview } from '../../shared/components/common-import/common-preview-tab-model';

@Component({
  selector: 'app-common-import-document',
  templateUrl: './common-import-document.component.html',
  styleUrls: ['./common-import-document.component.scss']
})
export class CommonImportDocumentComponent implements OnInit ,OnDestroy{
    @ViewChild(CommonImportComponent) commonImportComponent: CommonImportComponent;
  
  steps =['Upload','Map','Preview','Errors','Summary']
  staticSystemColumns = IMPORT_MODULE_SYSTEM_COLUMNS[ImportTemplateSource.Parts];
  inventorystemColumns = IMPORT_MODULE_SYSTEM_COLUMNS[ImportTemplateSource.Inventory];
  vendorPartsSytemColumns = IMPORT_MODULE_SYSTEM_COLUMNS[ImportTemplateSource.VendorParts];
  OEMExcessSystemColumns = IMPORT_MODULE_SYSTEM_COLUMNS[ImportTemplateSource.OEMExcess];
  consignmentSystemColumns = IMPORT_MODULE_SYSTEM_COLUMNS[ImportTemplateSource.Consignment];
  requiredField = IMPORT_MODULE_REQUIRED_FIELDS[ImportTemplateSource.Parts];
  requiredInventoryField = IMPORT_MODULE_REQUIRED_FIELDS[ImportTemplateSource.Inventory];
  requiredConsignmentField = IMPORT_MODULE_REQUIRED_FIELDS[ImportTemplateSource.Consignment];
  requiredVendorPartField = IMPORT_MODULE_REQUIRED_FIELDS[ImportTemplateSource.VendorParts];
  titles = ['Inventory','Part','OEMExcess','VendorParts','Consignment',];
  currentTabData :any ={}
  data :any ={}

  constructor(public tabsService: TabsService,public storageService: StorageService,private router: Router,public importDocumentsService: ImportDocumentsService,
    public toaster: ToastrService, public commonService: CommonService,
    public commonImportService:CommonImportDocumentService,
    public partsListService: PartsListService,
  ) {
    this.loadBlankData()
   }
loadBlankData(){
  this.data.importData  = {};
  this.data.mapData  = {};
  this.data.templateData  = {};
  this.data.errorData = {};
  this.data.previewData= {};
  this.data.errorData.duplicateData = {};
  this.data.templateData.selectedOption = '1'
}
  ngOnInit(): void {
    this.initialData(undefined)
    this.tabsService.onSubNavChanged.subscribe((url=>{
      if(url!== undefined)
        this.initialData(url)
    }));
  }
  initialData(currentUrl) {
    this.loadBlankData();
    const url = typeof currentUrl === 'string' ? currentUrl : this.router?.url;
    const urlSegment:any = url?.split('/')?.pop();
    // Reset import flags
    this.data.importConsignment = this.data.importOEMExcess = this.data.importInventory = this.data.importVendorParts = false;
    // Mapping URLs to configurations
    const configMap = {
      [this.titles[0]]: {
        importKey: 'importInventory',
        systemColumns: this.inventorystemColumns,
        previewModel: AgGridImportInventoryPreview,
        duplicateModel: AgGridImportCommonDuplicatesTab,
        sourceId:ImportTemplateSource.Inventory,
        sourcePath: ImportTemplateFileName?.IMPORT_INVENTORY,
        requiredField :this.requiredInventoryField
      },
      [this.titles[2]]: {
        importKey: 'importOEMExcess',
        systemColumns: this.OEMExcessSystemColumns,
        previewModel: AgGridImportOEMExcessPreview,
        duplicateModel: AgGridImportOEMExcessDuplicate,
        sourceId:ImportTemplateSource.OEMExcess,
        sourcePath: ImportTemplateFileName?.IMPORT_OEMEXCESS,
        requiredField :this.requiredVendorPartField
      },
      [this.titles[3]]: {
        importKey: 'importVendorParts',
        systemColumns: this.vendorPartsSytemColumns,
        previewModel: AgGridImportVendorPartsPreview,
        duplicateModel: AgGridImportOEMExcessDuplicate,
        sourceId:ImportTemplateSource.VendorParts,
        sourcePath: ImportTemplateFileName?.IMPORT_VENDOR_PART,
        requiredField :this.requiredVendorPartField
      },
      [this.titles[4]]: {
        importKey: 'importConsignment',
        systemColumns: this.consignmentSystemColumns,
        previewModel: AgGridImportConsignmentPreview,
        duplicateModel: AgGridImportConsignmentDuplicate,
        sourceId:ImportTemplateSource.Consignment,
        sourcePath: ImportTemplateFileName?.IMPORT_CONSIGNMENT,
        requiredField :this.requiredConsignmentField
      }
    };
    // Apply configuration if a match is found
    const config = configMap[urlSegment];
    if (config) {
      this.data[config.importKey] = true;
      this.data.mapData.staticSystemColumns = config.systemColumns;
      this.data.previewData.dataModel = config.previewModel;
      this.data.errorData.duplicateData.dataModel = config.duplicateModel;
      this.data.mapData.requiredField = config.requiredField ?? [];
      this.data.sourceId = config.sourceId;
      this.data.importData.sourcePath = config?.sourcePath;
    } else {
      this.data.mapData.staticSystemColumns = this.staticSystemColumns;
      this.data.mapData.requiredField = this.requiredField;
      this.data.previewData.dataModel = AgGridImportCommonPreview;
      this.data.errorData.duplicateData.dataModel = AgGridImportCommonDuplicatesTab;
      this.data.importData.sourcePath = ImportTemplateFileName.IMPORT_PART;
      this.data.sourceId = ImportTemplateSource.Parts
    }
    this.fillList();
  }
    isValid(values): boolean {
      let disabled = false; 
      switch (values) {
        case 4:
          if (this.data.errorData.isDuplicate) {disabled = false}
          else {
            this.data.errorData.isDuplicate = true;
            disabled = true
          }
          break;
        default:
          this.data.errorData.isDuplicate = false;
          break
      }
      return disabled;
    
    }

  async checkedValidation(values) {
     this.data.activeTab = values
    try {
      const urlSegment:any = this.router?.url?.split('/').pop();
      const validationMethods = {
        [this.titles[0]]: this.isValidInventory,
        [this.titles[1]]: this.isValidPart,
        [this.titles[2]]: this.isValidOemExcess,
        [this.titles[3]]: this.isValidVendorPart,
        [this.titles[4]]: this.isValidConsignment,
      };
  
      const validate = validationMethods[urlSegment];
      const success = validate ? await validate.call(this, values) : false;
  
      if (!success) {
        this.commonImportComponent.clickOnNext();
      }
    } catch (error) {
      console.error('Error during validation', error);
    }
  }
  isImportDataInvalid(importData: any): boolean {
    return !importData?.file ||
           !importData?.uploadSuccess ||
            importData?.headerValue ||
            importData?.emptyFile ||
            importData?.fileNotMatchError ||
            importData?.errorMessageSupported;
  }
   
  isValidPart(values: number): boolean {
    return this.validateStep(values,false,false,false,false,this.requiredField);
  }
  isValidInventory(values: number): boolean {
    return this.validateStep(values,true,false,false,false,this.requiredInventoryField);
  }
  isValidConsignment(values: number): boolean {
    return this.validateStep(values,false,true,false,false,this.requiredConsignmentField);
  }
  isValidOemExcess(values: number): boolean {
    return this.validateStep(values,false,false,true,false,this.requiredVendorPartField);
  }
  isValidVendorPart(values: number): boolean {
    return this.validateStep(values,false,false,false,true,this.requiredVendorPartField);
  }

 validateStep(values: number,checkInventory: boolean = false,checkConsignment: boolean = false,checkOemExcess: boolean = false,checkVendorPart: boolean = false,
  required:any[]): boolean {
  let disabled = false;
  switch (values) {
    case 1:
      disabled = this.isImportDataInvalid(this.data?.importData);
      if (checkInventory) {disabled = disabled || !this.data?.importData?.companyId || !this.data?.importData?.contactId;}
      else if (checkConsignment) {disabled = disabled || !this.data?.importData?.consignorId || !this.data?.importData?.contactId;}
      else if (checkOemExcess) {disabled = disabled || !this.data?.importData?.customerId || !this.data?.importData?.contactId;}
      else if (checkVendorPart) {disabled = disabled || !this.data?.importData?.vendorId || !this.data?.importData?.contactId;}
      this.data.importData.isValid = disabled;
      if(!disabled){this.commonService.getMapData.next(true)}
      break;
    case 2:
     this.importDocumentsService.submit=  this.importDocumentsService.checkRequiredMapValue(this.data?.mapData?.rowData,required);
      disabled =  !this.importDocumentsService.submit?true:false
      if(disabled){this.toaster.error("Please insert required field")
      this.importDocumentsService.mapValidation.next(false);
      return true
      }
      const value = ['Consigned Qty', 'Qty'];
      const mismatchedColumns = this.data?.mapData?.rowData
      ?.filter(x => value.includes(x.systemColumn) && x.systemColumn !== x.mappedColumn)
      .map(x => x.systemColumn);
     disabled = mismatchedColumns?.length > 0;
      if(disabled && this.importDocumentsService.submit){ this.toaster.error(`Mismatch in ${mismatchedColumns} column.`,'Mapping Error');
     this.importDocumentsService.mapValidation.next(false);
      return true
    }
      if(!disabled){
        // Set up templateData automatically (Template tab removed from stepper)
        this.data.templateData = {
          ...this.data.templateData,
          fileName: this.data.importData.fileName,
          mappingTemplateId: this.data?.importData?.mappingTemplateId ?? '0'
        };
        // Apply the selected template option and call the import API
        this.data.templateData.isValid = true;
        const data = this.data?.templateData;
        switch (Number(data?.selectedOption)) {
          case 1:
            disabled = !this.data?.createTemplate;
            if(disabled){
              this.getTemplateData(checkInventory,checkConsignment,checkOemExcess,checkVendorPart);
            }
            break;
          default:
            disabled = !this.data?.templateData?.templateName || !this.data?.createTemplate;
            if(this.data?.templateData?.templateName && disabled){
              this.getTemplateData(checkInventory,checkConsignment,checkOemExcess,checkVendorPart);
            }
            break;
        }
        this.data.createTemplate = false;
      }
    break;
    case 4:
      if (this.data.errorData.isDuplicate) {
        disabled = !this.data?.importPart;
        this.data.importPart = false
        if(disabled){
          this.importPart(checkInventory,checkConsignment,checkOemExcess,checkVendorPart)
        }
      }
      else { 
        this.data.errorData.importError = this.data.errorData.importError?? false;
        let value = this.data?.errorData?.rowData?.find((x:any) => x.correctField == '')?false:true; 
        if(!value){this.toaster.error("Please insert required field");}
        this.data.errorData.isDuplicate = value;
        disabled = true;
        this.importDocumentsService.errorValidation.next(false);
      }
      break;
    default:
      this.data.errorData.isDuplicate = this.data?.errorData?.isDuplicate??false;
      break
  }
  return disabled;
}
fillList() {
  this.data.importData.mappingTemplateList = this.data.importData.contactList  = this.data.importData.vendorList = this.data.importData.companyList =  this.data.importData.customerList  = this.data.importData.consignorList  = []
  this.importDocumentsService.getImportDropDownList().subscribe(res => {
    if(res?.isSuccess){
      let list = res?.response
      const urlSegment:any = this.router?.url?.split('/').pop();
      switch(urlSegment){
        case this.titles[0]:
          this.data.importData.mappingTemplateList = list?.inventoryTemplateList;
          this.data.importData.contactList  = list?.vendorContactList;
          this.data.importData.companyList  = list?.vendorNameList;
        break;
        case this.titles[1]:
          this.data.importData.mappingTemplateList = list?.partTemplateList;
        break;
        case this.titles[2]:
          this.data.importData.mappingTemplateList = list?.oemExcessTemplateList;
          this.data.importData.contactList  = list?.contactNameList;
          this.data.importData.customerList  = list?.customerCompanyNameList;
        break;
        case this.titles[3]:
          this.data.importData.mappingTemplateList = list?.vendorPartsTemplateList;
          this.data.importData.contactList  = list?.vendorContactList;
          this.data.importData.vendorList  = list?.vendorNameList;
        break;
        case this.titles[4]:
          this.data.importData.mappingTemplateList = list?.consignmentTemplateList;
          this.data.importData.contactList  = list?.contactNameList;
          this.data.importData.consignorList  = list?.companyNameList;
        break;
      }
      this.storageService.store('CONTACT_LIST', this.data.importData.contactList);
    }
  })
  this.importDocumentsService.mapValidation.next(true);
}
lastButtonClicked(nextId){
  this.tabsService.onSubNavChanged.next(nextId);
  this.initialData(undefined)
}
getTemplateData(checkInventory: boolean = false,checkConsignment: boolean = false,checkOemExcess: boolean = false, checkVendorPart: boolean = false){
  let importModel:any = this.data.importData;
  let mapModel: any = this.data.mapData;
  let templateModel: any = this.data.templateData;
  let list: any = [];
  list = mapModel?.rowData
  list.map((b) => {if (b.mappedColumn === b.systemColumn) {b.status = true}})
  list.map((a) => {if (mapModel?.requiredField?.includes(a.systemColumn)) { a.isRequired = true;} else {a.isRequired = false;}})
  mapModel.mappingTemplateList = list;
  const val = importModel?.mappingTemplateList?.map(a => a.name).includes(templateModel?.templateName);

  switch(templateModel.selectedOption){
    case '1':
      templateModel.isTemplateCreate = false;
      importModel.mappingTemplateId =  templateModel?.templateId??importModel?.mappingTemplateId;
    break;
    case '2':
      importModel.mappingTemplateId =  templateModel?.templateId??importModel?.mappingTemplateId;
      templateModel.isTemplateCreate = true;
    break;
    case '3':
      importModel.mappingTemplateId = '0'
      templateModel.isTemplateCreate = true;
    break;
  }
  if (importModel?.mappingTemplateId == '0' && val && templateModel?.isTemplateCreate) {
    this.toaster.error('Template already exists!!!')
  } else {
    if (checkInventory){this.importTemplate(this.titles[0])}
    else if (checkConsignment){this.importTemplate(this.titles[4])}
    else if (checkOemExcess){this.importTemplate(this.titles[2])}
    else if (checkVendorPart){this.importTemplate(this.titles[3])}
    else{this.importTemplate(this.titles[1])}
    
  }
}
importTemplate(importLabel){
  this.data.isLoading = true
  let importModel:any = this.data.importData;
  let mapModel: any = this.data.mapData;
  let templateModel: any = this.data.templateData;
  let serviceCall;
  let requestData:any = {
    importModel: {
      file: importModel?.file,
      mappingTemplateId: importModel?.mappingTemplateId,
    },
    templateData: {
      id: "",
      templateName:templateModel?.templateName ?? '',
      templateDescription:templateModel?.templateDescription ?? '',
      fileName: "",
      isTemplateCreate: templateModel?.isTemplateCreate,
      sourceId: this.data?.sourceId,
      templateMappingColumns: mapModel?.mappingTemplateList ?? []
    }   
  }

  switch(importLabel){
    case this.titles[0]:
      requestData.importModel = {
        ...requestData.importModel,
        companyId: importModel?.companyId,
        contactId: importModel?.contactId
      };
      requestData.isVendor = true;
      serviceCall = this.commonImportService.importInventoryTemplate;
    break;
    case this.titles[1]:
      serviceCall = this.commonImportService.importPartTemplate;
    break;
    case this.titles[2]:
      requestData.importModel = {
        ...requestData.importModel,
        companyId: importModel?.customerId,
        contactId: importModel?.contactId
      };
      serviceCall = this.commonImportService.importOemExcessTemplate;
    break;
    case this.titles[3]:
      requestData.importModel = {
        ...requestData.importModel,
        companyId: importModel?.vendorId,
        contactId: importModel?.contactId
      };
      serviceCall = this.commonImportService.importVendorPartTemplate;
    break;
    case this.titles[4]:
      requestData.importModel = {
        ...requestData.importModel,
        companyId: importModel?.consignorId,
        contactId: importModel?.contactId,
        payoutPercentage: importModel?.payoutPercentage
      };
      requestData.isVendor = true;
      serviceCall = this.commonImportService.importConsignmentTemplate;
    break;
  }

  serviceCall.call(this.commonImportService, requestData).subscribe({
    next:(res)=>{
    if (res?.isSuccess) {
      this.data.isLoading = false
      this.data.createTemplate = res?.isSuccess;
      this.data.previewData.rowData = res?.response?.moduleData?.data;
      this.data.errorData.rowData = res?.response?.moduleData?.importError;
      this.data.errorData.duplicateData.rowData = res?.response?.moduleData?.duplicatePotential;
      this.data.errorData.importError = !(res?.response?.moduleData?.importError?.length);
      this.checkedValidation(3);
      this.commonService.getMapData.next(true)
    } 
  },
  error:(err)=> {
    this.data.isLoading = false
    console.log(err);
  },
  })
}
importPart(checkInventory: boolean = false,checkConsignment: boolean = false,checkOemExcess: boolean = false,checkVendorPart: boolean = false){
  if(checkInventory){this.importTemplateComplete(this.titles[0])}
  else if(checkConsignment){this.importTemplateComplete(this.titles[4])}
  else if(checkOemExcess){this.importTemplateComplete(this.titles[2])}
  else if(checkVendorPart){this.importTemplateComplete(this.titles[3])}
  else{ this.importTemplateComplete(this.titles[1])}
  }

importTemplateComplete(importLabel){
  let model = this.data;
  let serviceCall;
  let requestData = {
    data:model?.previewData?.rowData,
    importError:model?.errorData?.rowData,
    duplicatePotential:model?.errorData?.duplicateData?.rowData,
    templateId:model?.importData?.mappingTemplateId,
  };
  switch(importLabel){
    case this.titles[0]:
      serviceCall = this.commonImportService.importInventory;
    break;
    case this.titles[1]:
      serviceCall = this.commonImportService.importPart;
    break;
    case this.titles[2]:
      serviceCall = this.commonImportService.importOemExcess;
    break;
    case this.titles[3]:
      serviceCall = this.commonImportService.importVendorPart;
    break;
    case this.titles[4]:
      serviceCall = this.commonImportService.importConsignment;
    break;
  }
  serviceCall.call(this.commonImportService, requestData).subscribe({
    next:(res)=>{
    if (res?.isSuccess) {
      this.data.importPart = res?.isSuccess;
      this.data.excludedRecords = res?.response?.excludedRecords;
      this.data.addedRecords = res?.response?.addedRecords;
      this.data.moveToEnd =  res?.isSuccess;
      this.checkedValidation(5)
    } },
    error:(err)=>{
      console.log(err);  
    }
  })

}
  ngOnDestroy(){
    this.tabsService.onSubNavChanged.next(undefined);
    this.commonService.getMapData.next(false)
  }
}
